export interface GoalPayload {
    id: number
    name: string
    slug: string
    sort_order: number
}

export class Goal {

    id: number
    name: string
    slug: string
    sortOrder: number

    constructor(data: GoalPayload) {
        this.id = data.id
        this.name = data.name
        this.slug = data.slug
        this.sortOrder = data.sort_order
    }

    fill(data: GoalPayload): this {
        this.id = data.id
        this.name = data.name
        this.slug = data.slug
        this.sortOrder = data.sort_order
        return this
    }

    payload(): GoalPayload {
        return {
            id: this.id,
            name: this.name,
            slug: this.slug,
            sort_order: this.sortOrder,
        }
    }
}
